// extracted by mini-css-extract-plugin
export default {"overlay":"Py-z","bodyOpen":"Qy-z","content":"Ry-z","header":"Sy-z","close":"Ty-z","closeNoHeading":"Uy-z"};